module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Db-Fc-Ga-Hb-Ia.deb7b50f.png";